import { Typography } from "@mui/material";
import React from "react";
import { cardTitleSx } from "../../theme";

export default function CardTitle(props) {
    const { title } = props;

    return (
        <Typography component="div" sx={{ ...cardTitleSx, marginBottom: "12px" }}>
            {title}
        </Typography>
    );
}